import { useParams } from "react-router-dom";
import EntityProvider from "pages/components/Behavior/EntityProvider";

import { Box } from "@mui/material";
import { getCreditorPayment } from "Application/Payment/PaymentService";
import { CreditorPayment } from "Domain/Payment/Entity/Payment";
import Section from "pages/components/Section";
import moment from "moment";
import { formatPrice, getDateFormat } from "pages/Utils/Formats";
import PaymentPayOuts from "./Parts/PaymentPayOuts";
import PaymentStatusChip from "pages/components/Status/PaymentStatusChip";

export default function CreditorPaymentDetails() {
  const { id = "" } = useParams<string>();

  return (
    <EntityProvider<CreditorPayment>
      callback={getCreditorPayment}
      params={[id]}
    >
      {(creditorPayment, setCreditorPayment) => (
        <div>
          <Box display={"grid"} gap={2} width={"100%"}>
            <CreditorPaymentSummery creditorPayment={creditorPayment} />
            <CreditorPaymentSection creditorPayment={creditorPayment} />
          </Box>
        </div>
      )}
    </EntityProvider>
  );
}

type CreditorPaymentProps = {
  creditorPayment: CreditorPayment;
};
function CreditorPaymentSummery({ creditorPayment }: CreditorPaymentProps) {
  return (
    <Section
      title={"payment_summary"}
      icon={<PaymentStatusChip status={creditorPayment.status} />}
    >
      <Box display={"flex"} justifyContent={"space-between"} width={"100%"}>
        <Box fontWeight={"bold"}>
          {moment(creditorPayment.date).format(getDateFormat())}
        </Box>

        <Box fontWeight={"bold"} color={"red"}>
          {formatPrice(creditorPayment.paymentAmount)}
        </Box>
      </Box>
    </Section>
  );
}

function CreditorPaymentSection({ creditorPayment }: CreditorPaymentProps) {
  return (
    <Section title={"creditor_payments_details"}>
      <Box width={"100%"}>
        <PaymentPayOuts paymentsOut={creditorPayment.paymentsOut} />
      </Box>
    </Section>
  );
}
